// Legacy component dimensions use a 16px reference. Express them in rem so
// typography and component geometry follow the same native root font size.
export const UI_DENSITY = 0.8;
export const REFERENCE_FONT_SIZE = 16;

export const toRem = (pixels) => `${pixels / REFERENCE_FONT_SIZE}rem`;

export function remDimensions(value) {
  if (Array.isArray(value)) return value.map(remDimensions);
  if (typeof value !== "string") return value;
  // Preserve quoted content and asset URLs, even when their names contain px.
  return value.replace(/url\([^)]*\)|"[^"]*"|'[^']*'|(-?(?:\d*\.)?\d+)px\b/g,
    (match, pixels) => pixels === undefined ? match : toRem(Number(pixels)));
}

// Runs after the standard JSS plugins have added units to numeric dimensions.
export function nativeDensityPlugin() {
  return {
    onProcessStyle(style, rule) {
      if (rule.type !== "style") return style;
      Object.keys(style).forEach((property) => {
        style[property] = remDimensions(style[property]);
      });
      return style;
    },
    onChangeValue: remDimensions,
  };
}

// MUI 5 uses Emotion instead of JSS, including for portalled menus and dialogs.
export function nativeDensityMiddleware(element) {
  if (element.type === "decl") {
    element.value = remDimensions(element.value);
  }
}

// Stored preferences keep their existing logical units. Pointer coordinates
// and available space are measured in actual rendered CSS pixels.
export function logicalPixels(pixels, referenceElement) {
  const rootFontSize = parseFloat(getComputedStyle(referenceElement.ownerDocument.documentElement).fontSize);
  return pixels * REFERENCE_FONT_SIZE / rootFontSize;
}
